import { useStore, useViewport } from "@xyflow/react"
import { memo, useMemo } from "react"
import { useCursor } from "../../contexts/cursor"

export const DragPreview = memo(() => {
	const { remoteCursors, peers } = useCursor()
	const viewport = useViewport()
	const nodes = useStore((state) => state.nodes)

	const draggingCursors = useMemo(() => {
		return Array.from(remoteCursors.values()).filter(
			(c) =>
				c.state === "dragging" && c.draggedNodes && c.draggedNodes.length > 0,
		)
	}, [remoteCursors])

	if (draggingCursors.length === 0) return null

	return (
		<>
			{draggingCursors.map((cursor) => {
				const userInfo = peers.get(cursor.connectionId)
				const draggedNodes = cursor.draggedNodes ?? []

				return draggedNodes.map((draggedNode, index) => {
					const node = nodes.find((n) => n.id === draggedNode.id)
					if (!node) return null

					// Get node dimensions from measured or default size
					const width = node.measured?.width ?? node.width ?? 280
					const height = node.measured?.height ?? node.height ?? 100

					// Transform canvas coordinates to screen coordinates
					const screenX = draggedNode.position.x * viewport.zoom + viewport.x
					const screenY = draggedNode.position.y * viewport.zoom + viewport.y

					return (
						<div
							key={`drag-${cursor.connectionId}-${draggedNode.id}`}
							className="pointer-events-none absolute rounded-lg border-2 border-dashed bg-white/5 backdrop-blur-sm"
							style={{
								transform: `translate(${screenX}px, ${screenY}px)`,
								width: width * viewport.zoom,
								height: height * viewport.zoom,
								borderColor: userInfo?.color ?? "#888",
							}}
						>
							{/* Only show label on first node */}
							{index === 0 && (
								<div
									className="absolute -top-6 left-0 whitespace-nowrap rounded px-1.5 py-0.5 text-xs text-white shadow-sm"
									style={{ backgroundColor: userInfo?.color ?? "#888" }}
								>
									{userInfo?.name ?? "User"} moving{" "}
									{draggedNodes.length > 1
										? `${draggedNodes.length} nodes`
										: ((node.data as { label?: string })?.label ?? "node")}
								</div>
							)}
						</div>
					)
				})
			})}
		</>
	)
})
